module.exports = __webpack_public_path__ + "ac14d65fd2e49826580f4157ff974744.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/arrow-down.svg
// module id = qzhV
// module chunks = 3